import Http from '../../http';
import * as types from './constants';

export const fetchSubscriptionAction = payload => ({
  type: types.FETCH_SUBSCRIPTION,
  payload,
});

export const fetchSubscription = (id, type) => async (dispatch) => {
  const response = await Http.get(`/${type}/${id}/subscription`);
  return dispatch(fetchSubscriptionAction(response));
};

export const addSubscription = (id, type, data) => async (dispatch) => {
  const response = await Http.post(`/${type}/${id}/subscription`, data);

  return dispatch(fetchSubscriptionAction(response));
};

const updateSubscriptionAction = payload => ({
  type: types.UPDATE_SUBSCRIPTION,
  payload,
});

export const updateSubscription = (id, type, data) => async (dispatch) => {
  const response = await Http.put(`/${type}/${id}/subscription`, data);

  return dispatch(updateSubscriptionAction(response));
};

export const fetchSubscriptionCharges = subscriptionId => async (dispatch) => {
  const response = await Http.get(`/subscription/${subscriptionId}/charge`, {
    sortBy: 'createdAt:desc',
  });

  return dispatch({
    type: types.FETCH_SUBSCRIPTION_CHARGE,
    payload: response.rows,
  });
};

export const createSubscriptionCharge = (subscriptionId, data) => async (dispatch) => {
  const response = await Http.post(`/subscription/${subscriptionId}/charge`, data);

  return dispatch({
    type: types.CREATE_SUBSCRIPTION_CHARGE,
    payload: response,
  });
};

export const refundSubscriptionCharge = (subscriptionId, chargeId, amount) => async (dispatch) => {
  const response = await Http.post(`/subscription/${subscriptionId}/charge/${chargeId}/refund`, {
    amount,
  });

  return dispatch({
    type: types.UPDATE_SUBSCRIPTION_CHARGE,
    payload: response,
  });
};

export const fetchSubscriptionInvoices = subscriptionId => async (dispatch) => {
  try {
    const response = await Http.get(`/subscription/${subscriptionId}/invoice`);
    return dispatch({
      type: types.FETCH_SUBSCRIPTION_INVOICE,
      payload: response.rows,
    });
  } catch (e) {
    dispatch({
      type: types.FETCH_SUBSCRIPTION_INVOICE,
      payload: [],
    });

    throw e;
  }
};

export const refundSubscriptionInvoice = (subscriptionId, invoiceId, amount) => async (dispatch) => {
  const response = await Http.put(`/subscription/${subscriptionId}/invoice/${invoiceId}/refund`, {
    amount,
  });

  return dispatch({
    type: types.UPDATE_SUBSCRIPTION_INVOICE,
    payload: response,
  });
};

export const paySubscriptionInvoice = (subscriptionId, invoiceId) => async (dispatch) => {
  const response = await Http.put(`/subscription/${subscriptionId}/invoice/${invoiceId}/pay`);

  return dispatch({
    type: types.UPDATE_SUBSCRIPTION_INVOICE,
    payload: response,
  });
};

export const markSubscriptionInvoiceUncollectible = (subscriptionId, invoiceId) => async (dispatch) => {
  const response = await Http.put(`/subscription/${subscriptionId}/invoice/${invoiceId}/mark-uncollectible`);

  return dispatch({
    type: types.UPDATE_SUBSCRIPTION_INVOICE,
    payload: response,
  });
};
